
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Punetokohlapur() {



  const cardData =
  {
    keyword: ' Pune to Kolhapur Cab',
    heading: 'SHREE Tours & Travels: Pune to Kolhapur Cab',
    headingDescription: 'SHREE Tours & Travels offers a dependable Pune to Kolhapur Cab service, ensuring a smooth and comfortable journey for travelers. Whether you’re visiting Kolhapur for its famous Mahalaxmi Temple, business, or leisure, our well-maintained Cabs provide a hassle-free travel experience. With experienced drivers and flexible booking options, we guarantee a safe and convenient ride. Enjoy a stress-free trip from Pune to Kolhapur with SHREE Tours & Travels, where customer satisfaction is our priority.',

    top: 'Top Places to Visit in Kolhapur with SHREE Tours & Travels ',

   "topPlaces": [
    {
        "title": "Mahalaxmi Temple",
        "description": "The Mahalaxmi Temple, also known as the Ambabai Temple, is Kolhapur’s most revered religious site, dedicated to Goddess Mahalaxmi. The temple, with its stunning architecture and spiritual aura, attracts thousands of devotees. Visitors can participate in daily rituals and seek blessings in this divine abode."
    },
    {
        "title": "Panhala Fort",
        "description": "Panhala Fort, perched atop the Sahyadri Hills, is a historic stronghold associated with Chhatrapati Shivaji Maharaj. Offering breathtaking views and fascinating stories of Maratha valor, this fort is perfect for history buffs and adventure seekers looking for a scenic trek."
    },
    {
        "title": "Rankala Lake",
        "description": "A serene getaway in the heart of Kolhapur, Rankala Lake is an ideal spot for relaxation, boating and evening strolls. The picturesque surroundings, combined with food stalls and gardens, make it a popular leisure destination for families and nature lovers."
    },
    {
        "title": "Jyotiba Temple",
        "description": "Situated on a hilltop, the Jyotiba Temple is a significant pilgrimage site dedicated to Lord Jyotiba. The temple offers stunning panoramic views and hosts vibrant annual fairs, attracting devotees and tourists seeking spiritual solace and a cultural experience."
    },
    {
        "title": "New Palace Museum",
        "description": "The New Palace, a grand structure built in Indo-Saracenic style, houses a museum showcasing the legacy of the Kolhapur royal family. Visitors can explore an impressive collection of artifacts, weapons and historical documents that narrate the region’s rich past."
    },
    {
        "title": "Chinmaya Ganadhish",
        "description": "Chinmaya Ganadhish is a beautifully designed temple dedicated to Lord Ganesha. Surrounded by lush gardens and a tranquil environment, it is an excellent place for meditation and spiritual rejuvenation."
    },
    {
        "title": "Shalini Palace",
        "description": "Overlooking Rankala Lake, Shalini Palace is an architectural gem that once served as a royal residence. Though now a heritage hotel, its elegant design and serene location make it a fascinating site to visit and capture stunning photographs."
    },
    {
        "title": "Khasbag Wrestling Stadium",
        "description": "Kolhapur is known for its wrestling tradition and the Khasbag Wrestling Stadium is a must-visit for sports enthusiasts. The largest wrestling arena in India, it offers an authentic glimpse into the city’s deep-rooted Kushti culture."
    },
    {
        "title": "Dajipur Wildlife Sanctuary",
        "description": "Located on the outskirts of Kolhapur, Dajipur Wildlife Sanctuary is home to the Indian bison (Gaur) and diverse flora and fauna. Ideal for wildlife lovers and adventure seekers, this sanctuary provides exciting trekking and bird-watching opportunities."
    },
    {
        "title": "Kolhapur Local Market",
        "description": "The bustling Kolhapur markets are famous for handcrafted Kolhapuri chappals, jewelry and local spices. Shopping here offers a unique cultural experience, allowing visitors to take home a piece of Kolhapur’s rich heritage."
    }
],  
    
            
 "services": [  
    {  
      "name": "Pune to Kolhapur Taxi",  
      "description": "Travel comfortably with SHREE Tours & Travels by booking a taxi from Pune to Kolhapur. Our well-maintained fleet and professional drivers ensure a smooth and hassle-free journey at competitive rates."  
    },  
    {  
      "name": "Pune to Kolhapur Cab Service",  
      "description": "Looking for a reliable Cab service from Pune to Kolhapur? We offer affordable one-way and round-trip Cab options with comfortable seating and experienced drivers for a stress-free ride."  
    },  
    {  
      "name": "Pune to Kolhapur One-Way Taxi",  
      "description": "Need a one-way taxi from Pune to Kolhapur? Book with SHREE Tours & Travels for a convenient and cost-effective ride. Enjoy a smooth journey without hidden charges."  
    },  
    {  
      "name": "Pune to Kolhapur Round Trip Cab",  
      "description": "Planning a round-trip to Kolhapur? Our Cab service offers flexible options for travelers who need to return on the same day or after a few days. Travel at your convenience with our well-maintained cars."  
    },  
    {  
      "name": "Affordable Pune to Kolhapur Cab",  
      "description": "Get budget-friendly Cab services from Pune to Kolhapur without compromising on quality and comfort. Enjoy a reliable and smooth travel experience at the best prices."  
    },  
    {  
      "name": "Private Taxi for Kolhapur from Pune",  
      "description": "Book a private taxi from Pune to Kolhapur for a personalized travel experience. Enjoy privacy, comfort and a seamless journey tailored to your schedule."  
    },  
    {  
      "name": "Kolhapur Tour from Pune by Cab",  
      "description": "Planning a Kolhapur tour from Pune? Our Cab service ensures a comfortable and convenient trip with sightseeing options and professional drivers for a memorable experience."  
    },  
    {  
      "name": "Kolhapur Cab Hire",  
      "description": "Hire a Cab from Pune to Kolhapur with SHREE Tours & Travels. We offer a variety of cars to suit your needs, from budget to luxury options."  
    },  
    {  
      "name": "Group Travel from Pune to Kolhapur",  
      "description": "Traveling with a group? Book our spacious and comfortable Cabs for a smooth group travel experience from Pune to Kolhapur."  
    },  
    {  
      "name": "Book Pune to Kolhapur Car",  
      "description": "Rent a car for your Pune to Kolhapur journey with ease. Choose from sedans, SUVs and tempo travelers for a comfortable ride."  
    },  
    {  
      "name": "Kolhapur Cab Booking from Pune",  
      "description": "Easily book a Cab from Pune to Kolhapur with our reliable online booking service. Enjoy timely pickups and professional service at affordable rates."  
    },  
    {  
      "name": "Pune to Kolhapur Luxury Taxi",  
      "description": "Experience a premium travel experience with our luxury taxi service from Pune to Kolhapur. Choose high-end vehicles like Innova Crysta, Kia Carnival, or premium sedans."  
    },  
    {  
      "name": "Pune to Kolhapur Cheap Cab",  
      "description": "Looking for an economical Cab option? We offer budget-friendly and reliable taxi services for your Pune to Kolhapur trip."  
    },  
    {  
      "name": "Kolhapur Trip by Cab",  
      "description": "Plan your Kolhapur trip with our convenient Cab service. Enjoy a smooth and comfortable journey with professional drivers."  
    },  
    {  
      "name": "Pune to Kolhapur Road Trip",  
      "description": "Planning a scenic road trip from Pune to Kolhapur? Our Cab service provides comfortable vehicles and experienced drivers to make your journey enjoyable."  
    },  
    {  
      "name": "Pune to Kolhapur Taxi for Family",  
      "description": "Traveling with family? Our family-friendly taxi service ensures a safe, comfortable and hassle-free ride from Pune to Kolhapur."  
    },  
    {  
      "name": "Pune to Kolhapur Comfort Cab",  
      "description": "Book a comfortable Cab for your Pune to Kolhapur journey. Our well-maintained fleet and professional chauffeurs guarantee a pleasant ride."  
    },  
    {  
      "name": "Kolhapur Sightseeing Cab",  
      "description": "Explore Kolhapur with our sightseeing Cab service. Visit popular attractions in a comfortable vehicle with an experienced driver."  
    }  
],  

"tableData": [  
    ["- Pune to Kolhapur Taxi", "- Pune to Kolhapur Cab Service"],  
    ["- Pune to Kolhapur One-Way Taxi", "- Pune to Kolhapur Round Trip Cab"],  
    ["- Affordable Pune to Kolhapur Cab", "- Private Taxi for Kolhapur from Pune"],  
    ["- Kolhapur Tour from Pune by Cab", "- Kolhapur Cab Hire"],  
    ["- Group Travel from Pune to Kolhapur", "- Book Pune to Kolhapur Car"],  
    ["- Kolhapur Cab Booking from Pune", "- Pune to Kolhapur Luxury Taxi"],  
    ["- Pune to Kolhapur Cheap Cab", "- Kolhapur Trip by Cab"],  
    ["- Pune to Kolhapur Road Trip", "- Pune to Kolhapur Taxi for Family"],  
    ["- Pune to Kolhapur Comfort Cab", "- Kolhapur Sightseeing Cab"]  
],
  
whychoose: [
    {
      "WhyChooseheading": "Comfortable Journey",
      "WhyChoosedescription": "Our Pune to Kolhapur Cabs offer a smooth and comfortable ride, ensuring that your journey is enjoyable from start to finish. With spacious interiors and comfortable seating, you can relax during your trip. Whether you're traveling alone, with family, or in a group, our vehicles are designed to provide maximum comfort throughout the ride."
    },
    {
      "WhyChooseheading": "Experienced Drivers",
      "WhyChoosedescription": "Our drivers are highly skilled and well-versed in the routes from Pune to Kolhapur. With years of experience on these roads, they ensure a safe, smooth and timely trip. You can relax knowing that you’re in good hands with our professional chauffeurs who prioritize your safety and comfort."
    },
    {
      "WhyChooseheading": "Affordable Pricing",
      "WhyChoosedescription": "We offer competitive and affordable rates for your Pune to Kolhapur Cab journey. Our pricing is transparent, with no hidden fees, so you can be sure you're getting great value for your money. Whether you're booking a one-way trip or a round trip, we provide budget-friendly options to fit your needs."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "All our vehicles are regularly serviced and maintained to the highest standards. From mechanical inspections to cleanliness, we ensure that every vehicle is in top condition before your trip. Whether you're traveling for a few hours or the entire day, you can trust that your ride will be comfortable and safe."
    },
    {
      "WhyChooseheading": "Flexible Rental Options",
      "WhyChoosedescription": "We offer flexible rental packages for your Pune to Kolhapur journey. Whether you need a Cab for a few hours, a full day, or multiple days, we can customize the rental to suit your schedule. Choose the package that best fits your travel plans and enjoy a hassle-free experience."
    },
    {
      "WhyChooseheading": "Easy Booking Process",
      "WhyChoosedescription": "Booking a Cab from Pune to Kolhapur is quick and easy with us. You can easily make a reservation through our online platform or by contacting our customer service team. Whether you're planning ahead or need a last-minute ride, we make booking seamless and stress-free."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer round-the-clock service for your Pune to Kolhapur Cab needs. No matter when you need to travel, we are always ready to assist you with timely and reliable transportation. Whether you have an early morning trip or a late-night departure, we are here to accommodate your schedule."
    },
    {
      "WhyChooseheading": "Local Insights",
      "WhyChoosedescription": "Our drivers have extensive knowledge of the local areas, including places to visit and attractions between Pune and Kolhapur. If you’re interested in sightseeing along the way, they can provide you with valuable recommendations for spots to check out, ensuring your journey is as enriching as it is enjoyable."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, customer satisfaction is our top priority. We are committed to providing an exceptional travel experience that meets and exceeds your expectations. With a focus on quality service, comfort and reliability, we ensure that every trip is memorable and enjoyable."
    }
  ]
  



        
  }

  const faqData = [
    {
        question: "How can I book a Cab from Pune to Kolhapur?",
        answer: "You can easily book your Pune to Kolhapur Cab through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of Cabs do you offer for the Pune to Kolhapur route?",
        answer: "We offer a variety of vehicles for the Pune to Kolhapur journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates from Pune to Kolhapur inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a Cab for a one-way trip from Pune to Kolhapur?",
        answer: "Yes, we offer one-way rental options for your Pune to Kolhapur trip."
    },
    {
        question: "Do you provide drivers with the rental Cab for the Pune to Kolhapur trip?",
        answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for a Pune to Kolhapur Cab booking?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for the Pune to Kolhapur Cab booking?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for the Pune to Kolhapur trip?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Cab from Pune to Kolhapur?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a Cab from Pune to Kolhapur?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'The trip from Pune to Kolhapur was fantastic! The driver was very professional and the car was comfortable throughout the journey.',
        name: 'Mr. Rahul Joshi',
    },
    {
        text: 'I had a smooth and pleasant experience with SHREE Tours & Travels for my Pune to Kolhapur trip. Highly recommend their service!',
        name: 'Miss. Ananya Patil',
    }
];




  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


  const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];


  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Kolhapur Cab",
  "description": "Book an affordable and reliable Pune to Kolhapur cab service with S9 Travels. Enjoy a comfortable and safe ride in well-maintained vehicles, driven by professional drivers. Choose from one-way or round-trip options for a smooth, hassle-free journey. Ideal for group travel, family trips, or solo adventures.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2890"
  }
};


  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Pune to Kolhapur Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Cab from Pune to Kolhapur with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Pune to Kolhapur Taxi, Pune to Kolhapur Cab Service, Pune to Kolhapur One-Way Taxi, Pune to Kolhapur Round Trip Cab, Affordable Pune to Kolhapur Cab, Private Taxi for Kolhapur from Pune, Kolhapur Tour from Pune by Cab, Kolhapur Cab Hire, Group Travel from Pune to Kolhapur, Book Pune to Kolhapur Car, Kolhapur Cab Booking from Pune, Pune to Kolhapur Luxury Taxi, Pune to Kolhapur Cheap Cab, Kolhapur Trip by Cab, Pune to Kolhapur Road Trip, Pune to Kolhapur Taxi for Family, Pune to Kolhapur Comfort Cab, Kolhapur Sightseeing Cab" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/1.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}




              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetokohlapur;